module.exports = __webpack_public_path__ + "static/media/drawer.25a0b15f.svg";